export const BASE_API_PATH: string =
  process.env["REACT_APP_API_PATH"] || "https://api.dev.capablehealth.com";
